import { render, staticRenderFns } from "./BulkActionsDropdown.vue?vue&type=template&id=06a752c8"
import script from "./BulkActionsDropdown.vue?vue&type=script&lang=js"
export * from "./BulkActionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./BulkActionsDropdown.vue?vue&type=style&index=0&id=06a752c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports